import { apiGet, apiBasic } from "./requests";
export const getCashState = () => apiGet("cash-register");
export const getCashHistory = (page) =>
  apiGet("cash-register/history", { page, pageSize: 20 });
export const getCashClose = (id) =>
  apiGet(`cash-register/shifts/${encodeURIComponent(id)}`);
export const submitCashOperation = (operation) =>
  apiBasic(operation.body, operation.path);
